/* ============================================================
   WUNSCHLOGO-KARTE · Lieblingscap
   Reines Vanilla JS, eine Fremdbibliothek nur bei Bedarf.

   FARBERKENNUNG
   PNG und SVG zeichnet der Browser selbst auf eine unsichtbare
   Flaeche, danach zaehlen wir die Bildpunkte. PDF kann er nicht -
   dafuer wird pdf.js nachgeladen, aber ERST wenn jemand wirklich
   eine PDF waehlt. Die Bibliothek ist rund ein Megabyte; sie auf
   jeder Produktseite mitzuladen waere Verschwendung.

   Gezaehlt wird auf einem groben Raster und Farben unter zwei
   Prozent Flaechenanteil werden verworfen. Ohne diese Toleranz
   zaehlt jede weiche Kante als eigene Farbe und ein schlichter
   schwarzer Schriftzug kaeme auf zwanzig.

   Die Erkennung entscheidet nichts endgueltig: Der Kunde kann die
   Art des Logos jederzeit selbst umstellen. Faellt die Erkennung
   aus, bleibt seine Auswahl massgeblich.
   ============================================================ */
(function () {
  'use strict';

  var root = document.getElementById('wunschlogo-karte');
  if (!root) return;

  var CFG = JSON.parse(root.dataset.config);
  var ORDER = ['vorne', 'hinten', 'links', 'rechts'];
  var AKTIV = ORDER.filter(function (p) { return CFG.positionen.indexOf(p) !== -1; });

  var ARTEN = {
    schrift: { name: 'Schriftzug', note: 'Eine Farbe', icon: '𝐀' },
    symbol:  { name: 'Symbol',     note: 'Ein bis zwei Farben', icon: '◆' },
    komplex: { name: 'Komplex',    note: 'Ab drei Farben', icon: '◍' }
  };

  var SVG = {
    vorne: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M22 60 A38 40 0 0 1 98 60 Z"/>' +
      '<path class="wl-cap" d="M60 20 L60 60"/>' +
      '<path class="wl-cap" d="M20 60 C22 80 98 80 100 60"/>' +
      '<rect class="wl-area" x="34" y="36" width="52" height="18" rx="2"/></svg>',
    hinten: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M22 60 A38 40 0 0 1 98 60"/>' +
      '<path class="wl-cap" d="M22 60 L50 60 M70 60 L98 60"/>' +
      '<path class="wl-cap" d="M50 60 L50 48 M70 60 L70 48"/>' +
      '<path class="wl-cap" d="M46 52 L74 52"/>' +
      '<rect class="wl-area" x="36" y="28" width="48" height="15" rx="2"/></svg>',
    links: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M30 62 A34 38 0 0 1 96 62 Z"/>' +
      '<path class="wl-cap" d="M96 62 C112 62 116 72 108 76 L92 71"/>' +
      '<rect class="wl-area" x="46" y="42" width="30" height="15" rx="2"/></svg>',
    rechts: '<svg viewBox="0 0 120 92" aria-hidden="true"><g transform="translate(120,0) scale(-1,1)">' +
      '<path class="wl-cap" d="M30 62 A34 38 0 0 1 96 62 Z"/>' +
      '<path class="wl-cap" d="M96 62 C112 62 116 72 108 76 L92 71"/>' +
      '<rect class="wl-area" x="46" y="42" width="30" height="15" rx="2"/></g></svg>'
  };

  /* Produktspezifische Vorderansichten fuer die Positionskachel. */
  var PRODUKT_SVG = {
    socke: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M43 10 H72 V49 C72 58 78 63 88 64 L100 66 C106 67 107 73 101 77 C88 86 69 85 58 77 C49 70 44 61 43 51 Z"/>' +
      '<path class="wl-cap" d="M43 19 H72 M43 24 H72"/>' +
      '<rect class="wl-area" x="50" y="29" width="16" height="24" rx="2"/></svg>',
    tasche: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M29 31 H91 L86 79 H34 Z"/>' +
      '<path class="wl-cap" d="M43 31 C43 13 77 13 77 31"/>' +
      '<rect class="wl-area" x="42" y="45" width="36" height="22" rx="2"/></svg>',
    muetze: '<svg viewBox="0 0 120 92" aria-hidden="true">' +
      '<path class="wl-cap" d="M34 57 C34 30 45 17 60 17 C75 17 86 30 86 57"/>' +
      '<path class="wl-cap" d="M31 56 H89 V77 H31 Z"/>' +
      '<path class="wl-cap" d="M60 17 V56"/>' +
      '<rect class="wl-area" x="41" y="61" width="38" height="11" rx="2"/></svg>'
  };

  function positionsSkizze(p) {
    return (p === 'vorne' && PRODUKT_SVG[CFG.stickTyp]) ? PRODUKT_SVG[CFG.stickTyp] : SVG[p];
  }

  var stand = {
    gewaehlt: {},
    breite: 6,
    hoehe: 3,
    seiten: 2,
    art: 'schrift',
    farbAnzahl: null,
    farbListe: [],
    zuordnung: [],
    dateiName: '',
    istPdf: false,
    hatDatei: false
  };
  AKTIV.forEach(function (p, i) { stand.gewaehlt[p] = (i === 0); });

  var el = {
    zone: document.getElementById('wl-zone'),
    datei: document.getElementById('wl-datei'),
    name: document.getElementById('wl-name'),
    info: document.getElementById('wl-info'),
    knopf: document.getElementById('wl-knopf'),
    marken: document.getElementById('wl-marken'),
    arten: document.getElementById('wl-arten'),
    positionen: document.getElementById('wl-positionen'),
    preiszeile: document.getElementById('wl-preiszeile'),
    breite: document.getElementById('wl-breite'),
    hoehe: document.getElementById('wl-hoehe'),
    grenze: document.getElementById('wl-grenze'),
    warnung: document.getElementById('wl-warnung'),
    vorschau: document.getElementById('wl-vorschau'),
    flaeche: document.getElementById('wl-flaeche'),
    logoBox: document.getElementById('wl-logo-box'),
    logo: document.getElementById('wl-logo'),
    griff: document.getElementById('wl-resize-handle'),
    leer: document.getElementById('wl-leer'),
    anfrage: document.getElementById('wl-anfrage'),
    yarnEinzel: document.getElementById('wl-yarn-einzel'),
    zuordnung: document.getElementById('wl-zuordnung'),
    zeilen: document.getElementById('wl-zeilen'),
    props: document.getElementById('wl-props'),
    blocker: document.getElementById('wl-blocker'),
    logoBereichA: document.getElementById('wl-logo-bereich-a'),
    logoBereichB: document.getElementById('wl-logo-bereich-b'),
    logoBereichC: document.getElementById('wl-logo-bereich-c'),
    yarnText: document.getElementById('wl-yarn-text'),
    seitenBloecke: document.getElementById('wl-seiten-blocks'),
    yarnText: document.getElementById('wl-yarn-text')
  };

  function k(n, s) { return n.toFixed(s === undefined ? 1 : s).replace('.', ','); }
  function anzahl() { return AKTIV.filter(function (p) { return stand.gewaehlt[p]; }).length; }

  /* Bildquelle fuer eine Position: falls fuer "vorne" ein Farbfoto
     hinterlegt ist (CFG.farbFotos, z.B. bei der Tasche mit 12 Farben),
     wird dieses verwendet. Ansonsten das normale Foto. Farbfotos
     gelten nur fuer die Position "vorne" - fuer Hinten/Links/Rechts
     werden immer die neutralen Seitenfotos verwendet. */
  function fotoQuelle(foto, position) {
    if (!foto) return null;
    if (position === 'vorne' && CFG.farbFotos && CFG.farbFotos[CFG.farbeAktuell]) {
      return CFG.farbFotos[CFG.farbeAktuell];
    }
    return foto.src;
  }

  /* Liest die gerade am Produkt gewaehlte erste Variantenoption (bei
     uns immer die Farbe) direkt aus Dawns <variant-selects> - gleiche
     Abfrage wie Dawns eigene VariantSelects.getAllSelectedOptions() in
     global.js, damit es sowohl bei Swatches/Buttons (fieldset) als
     auch bei Dropdowns (.product-form__input--dropdown) funktioniert. */
  function aktuelleFarbe() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return CFG.farbeAktuell;
    var gruppe = vs.querySelector('fieldset, .product-form__input--dropdown');
    if (!gruppe) return CFG.farbeAktuell;
    var gewaehlt = gruppe.querySelector('input:checked') || gruppe.querySelector('select option[selected]');
    return gewaehlt ? gewaehlt.value : CFG.farbeAktuell;
  }

  /* Logo gibt es nur noch vorne - Groesse, Vorschau und Grenzen
     beziehen sich deshalb immer fest auf diese eine Flaeche, nicht
     mehr auf die erste ausgewaehlte Position. */
  function maxHoehe() { return Math.min(CFG.maxHoehe, CFG.flaechen.vorne.h); }

  function seitePosAktiv() {
    return ['hinten', 'links', 'rechts'].some(function (p) { return stand.gewaehlt[p]; });
  }

  /* Seiten (Hinten/Links/Rechts) tragen nur Text - kein Logo, keine
     Farberkennung. Zeigt/versteckt den Logo-Bereich, je nachdem ob
     Vorne gerade ausgewaehlt ist, und die Text-Garnfarbe, je nachdem
     ob mindestens eine Seitenposition ausgewaehlt ist. Logo und Text
     haben absichtlich getrennte Garnfarben. */
  function zeichneSichtbarkeiten() {
    if (el.logoBereichA) el.logoBereichA.hidden = !stand.gewaehlt.vorne;
    if (el.logoBereichB) el.logoBereichB.hidden = !stand.gewaehlt.vorne;
    if (el.logoBereichC) el.logoBereichC.hidden = !stand.gewaehlt.vorne;
    if (el.yarnText) el.yarnText.hidden = !seitePosAktiv();
  }

  /* ---------- Seitenbloecke: Text statt Logo ----------
     Ein eigener Block pro ausgewaehlter Seitenposition - Text,
     Schriftart, Groesse, Vorschau. Gleiches Rechenmodell wie bei der
     Stickerei-Karte (stickerei-karte.js), hier auf die Seiten
     beschraenkt, denn vorne bleibt beim Logo. */
  var CAP_RATIO = 0.70;
  var LINE_PITCH = 1.25;
  var DESCENDER = 0.22;
  var seitenCtx = document.createElement('canvas').getContext('2d');

  AKTIV.forEach(function (p) {
    if (p === 'vorne') return;
    stand.daten = stand.daten || {};
    stand.daten[p] = { text: '', zeilen: ['', '', ''], schrift: null, groesse: CFG.flaechen[p].min };
  });

  /* Baut den Canvas-/CSS-font-String inkl. Schriftschnitt (fuer Fett/Kursiv-
     Varianten wie "Arimo Bold Italic" - ohne das misst seitenBreiteCm() mit
     dem falschen, meist schmaleren Schnitt und die Breitenpruefung wird
     falsch). */
  function schriftSchnitt(font) {
    var gewicht = (font.weight && font.weight !== '400') ? font.weight + ' ' : '';
    var stil = (font.style && font.style !== 'normal') ? font.style + ' ' : '';
    return stil + gewicht;
  }
  function seitenBreiteCm(text, font, capCm) {
    if (!text || !font) return 0;
    if (font.css) {
      seitenCtx.font = schriftSchnitt(font) + '100px ' + font.css;
      return (seitenCtx.measureText(text).width / 100) * (capCm / CAP_RATIO);
    }
    return text.length * font.faktor * capCm;
  }
  function seitenHoeheCm(n, capCm) {
    return ((n - 1) * LINE_PITCH + 1 + DESCENDER) * capCm;
  }
  function seitenMaxGroesseFuerZeilen(n, a) {
    var passt = a.h / ((n - 1) * LINE_PITCH + 1 + DESCENDER);
    return Math.min(a.max, Math.max(a.min, Math.floor(passt * 10) / 10));
  }
  function seitenMaxZeichen(text, font, capCm, maxW) {
    var n = text.length;
    while (n > 0 && seitenBreiteCm(text.slice(0, n), font, capCm) > maxW) n--;
    return n;
  }
  function seitenMaxGroesseFuerBreite(text, font, a, deckel) {
    for (var v = deckel; v >= a.min; v = Math.round((v - 0.1) * 10) / 10) {
      if (seitenBreiteCm(text, font, v) <= a.w) return v;
    }
    return null;
  }
  function seitenGroessenwort(cm) {
    if (cm < 1.25) return 'klein';
    if (cm < 1.75) return 'mittel';
    if (cm < 2.25) return 'groß';
    if (cm < 3.00) return 'sehr groß';
    return 'extra groß';
  }

  /* Liest die aktuell gewaehlte Garnfarbe fuer die Textfarbe in der
     Vorschau - eigenes Farbfeld, unabhaengig vom Logo (dasselbe
     Muster wie bei der Stickerei-Karte, hier auf #wl-yarn-text
     eingegrenzt, damit nicht versehentlich die Logo-Farbe greift). */
  function garnFarbe() {
    if (!el.yarnText) return null;
    var gew = el.yarnText.querySelector(
      '[data-garn-hex][aria-checked="true"], [data-hex][aria-pressed="true"], [data-hex].is-selected, [data-hex]:checked'
    );
    if (!gew) return null;
    return gew.dataset.garnHex || gew.dataset.hex || null;
  }

  function zeichneSeitenBloecke() {
    if (!el.seitenBloecke) return;
    el.seitenBloecke.innerHTML = '';
    AKTIV.filter(function (p) { return p !== 'vorne' && stand.gewaehlt[p]; })
      .forEach(function (p) { el.seitenBloecke.appendChild(baueSeitenBlock(p)); });
    skaliereSeiten();
  }

  function baueSeitenBlock(p) {
    var a = CFG.flaechen[p], s = stand.daten[p];
    var box = document.createElement('div');
    box.className = 'wl__block wl__block--' + p;

    var h = document.createElement('h4');
    h.innerHTML = a.label + ' <span class="wl__block-dim">Stickfläche ' + a.w + ' × ' + k(a.h) +
      ' cm · max. ' + a.zeilen + (a.zeilen === 1 ? ' Zeile' : ' Zeilen') + '</span>';
    box.appendChild(h);

    /* Text: EIN Feld statt einzelner Zeilen-Inputs - Enter erzeugt eine
       neue Zeile, bis zur je Position erlaubten Zeilenzahl (a.zeilen).
       Baugleich mit stickerei-karte.js (siehe dortiger Kommentar zum
       "text"-Feld als einzige Quelle fuer den Textfeld-Wert). */
    var maxZeichenGesamt = 40 * a.zeilen;
    var ta = document.createElement('textarea');
    ta.className = 'wl__textarea';
    ta.rows = a.zeilen;
    ta.maxLength = maxZeichenGesamt;
    ta.placeholder = 'Dein Text';
    ta.value = s.text || '';
    ta.dataset.key = p + '-txt';
    ta.addEventListener('focus', function () { ta.select(); });
    ta.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var vorherigeZeilen = ta.value.slice(0, ta.selectionStart).split('\n').length;
      if (vorherigeZeilen >= a.zeilen) e.preventDefault();
    });
    ta.addEventListener('input', function (e) {
      s.text = e.target.value;
      var zeilen = s.text.split('\n').slice(0, a.zeilen);
      for (var z = 0; z < a.zeilen; z++) { s.zeilen[z] = zeilen[z] || ''; }
      aktualisiereSeiten(p + '-txt', ta.selectionStart);
    });
    box.appendChild(ta);

    var c = document.createElement('div');
    c.className = 'wl__block-count';
    c.textContent = ta.value.length + ' / ' + maxZeichenGesamt;
    box.appendChild(c);

    var zh = document.createElement('p');
    zh.className = 'wl__zeilen-hint';
    zh.textContent = a.zeilen > 1
      ? 'Enter für neue Zeile (max. ' + a.zeilen + ').'
      : 'Nur eine Zeile möglich auf dieser Fläche.';
    box.appendChild(zh);

    /* Schriftkacheln: zeigen den eigenen Text */
    var ersteZeile = (s.zeilen.find(function (t) { return t && t.trim(); }) || '').trim();
    var probe = ersteZeile ? ersteZeile.slice(0, 14) : 'Dein Text';

    var fl = document.createElement('p');
    fl.className = 'wl__label';
    fl.style.margin = '0 0 8px';
    fl.innerHTML = 'Schriftart <span class="wl__pflicht">*</span>';
    box.appendChild(fl);

    var fg = document.createElement('div');
    fg.className = 'wl__fonts';
    CFG.schriften.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl__font';
      b.setAttribute('aria-pressed', s.schrift === f.id);
      var span = document.createElement('span');
      span.className = 'wl__font-s';
      span.style.fontFamily = f.css;
      span.style.fontWeight = f.weight || '400';
      span.style.fontStyle = f.style || 'normal';
      span.textContent = probe;
      var lab = document.createElement('span');
      lab.className = 'wl__font-l';
      lab.textContent = f.name;
      b.appendChild(span); b.appendChild(lab);
      /* Schriftart gilt fuer alle Textpositionen gleichzeitig - der
         Kunde soll nicht auf jeder Position eine andere Schrift
         waehlen koennen. Deshalb hier auf alle Seiten-Daten
         schreiben, nicht nur auf die aktuelle Position. */
      b.addEventListener('click', function () {
        AKTIV.filter(function (pp) { return pp !== 'vorne'; }).forEach(function (pp) {
          stand.daten[pp].schrift = f.id;
        });
        aktualisiereSeiten();
      });
      fg.appendChild(b);
    });
    box.appendChild(fg);

    /* Slider: Obergrenze haengt an der Zeilenanzahl */
    var genutzt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim().length; });
    var nZeilen = Math.max(1, genutzt.length);
    var deckel = seitenMaxGroesseFuerZeilen(nZeilen, a);
    if (s.groesse > deckel) s.groesse = deckel;

    var row = document.createElement('div');
    row.className = 'wl__slrow';
    row.innerHTML = '<span class="wl__label" style="margin:0">Schriftgröße</span>' +
      '<span class="wl__slval">' + k(s.groesse) + ' cm <em>· ' + seitenGroessenwort(s.groesse) + '</em></span>';
    box.appendChild(row);
    var slval = row.querySelector('.wl__slval');

    var sl = document.createElement('input');
    sl.type = 'range'; sl.min = a.min; sl.max = deckel; sl.step = 0.1; sl.value = s.groesse;
    sl.addEventListener('input', function (e) { s.groesse = parseFloat(e.target.value); aktualisiereSeiten(); });
    box.appendChild(sl);

    var ends = document.createElement('div');
    ends.className = 'wl__slends';
    ends.innerHTML = '<span>' + k(a.min) + ' cm</span><span>' + k(deckel) + ' cm</span>';
    box.appendChild(ends);

    if (deckel < a.max) {
      var lh = document.createElement('p');
      lh.className = 'wl__hinweis';
      lh.style.margin = '-6px 0 12px';
      lh.textContent = 'Bei ' + nZeilen + ' Zeilen sind höchstens ' + k(deckel) +
        ' cm möglich — die Fläche ist ' + k(a.h) + ' cm hoch.';
      box.appendChild(lh);
    }

    /* Vorschau auf der echten Stickflaeche */
    var font = CFG.schriften.filter(function (f) { return f.id === s.schrift; })[0];
    var foto = CFG.fotos[p];
    var prev = document.createElement('div');
    prev.className = 'wl__blockprev';
    var ziel;

    if (foto && foto.src) {
      prev.classList.add('wl__bp-photo');
      if (foto.spiegeln) prev.classList.add('wl__bp-flip');
      prev.style.aspectRatio = foto.ratio;
      prev.style.backgroundImage = 'url("' + fotoQuelle(foto, p) + '")';
      prev.dataset.areaw = foto.cmWide;

      var cmHoch = foto.cmWide / foto.ratio;
      var lift = (foto.liftCm || 0) / cmHoch;
      var feld = document.createElement('div');
      feld.className = 'wl__bp-field';
      feld.style.width = (a.w / foto.cmWide * 100) + '%';
      feld.style.height = (a.h / cmHoch * 100) + '%';
      feld.style.left = (foto.cx * 100) + '%';
      feld.style.top = ((foto.cy - lift) * 100) + '%';
      prev.appendChild(feld);
      ziel = feld;
    } else {
      prev.style.aspectRatio = a.w + ' / ' + a.h;
      prev.dataset.areaw = a.w;
      ziel = prev;
    }

    var zuBreit = null;
    if (genutzt.length && font) {
      genutzt.forEach(function (t) {
        var w = seitenBreiteCm(t, font, s.groesse);
        if (w > a.w && (!zuBreit || w > zuBreit.w)) zuBreit = { t: t, w: w };
      });
      var inner = document.createElement('div');
      inner.className = 'wl__bp-txt';
      inner.style.fontFamily = font.css;
      inner.style.fontWeight = font.weight || '400';
      inner.style.fontStyle = font.style || 'normal';
      inner.style.lineHeight = (LINE_PITCH * CAP_RATIO).toFixed(3);
      inner.style.color = garnFarbe() || 'currentColor';
      inner.dataset.size = s.groesse;
      inner.textContent = genutzt.join('\n');
      ziel.appendChild(inner);
      aktiviereTextGriff(inner, ziel, a, s, nZeilen, deckel, sl, slval);
    } else {
      var e = document.createElement('span');
      e.className = 'wl__bp-empty';
      e.textContent = !genutzt.length ? 'Text eingeben' : 'Schriftart wählen';
      prev.appendChild(e);
    }
    if (zuBreit) prev.classList.add('wl__bp-bad');
    box.appendChild(prev);

    if (zuBreit) {
      var passt = seitenMaxZeichen(zuBreit.t, font, s.groesse, a.w);
      var kleiner = seitenMaxGroesseFuerBreite(zuBreit.t, font, a, deckel);
      var w2 = document.createElement('div');
      w2.className = 'wl__block-warn';
      w2.innerHTML = 'Zu breit für ' + a.w + ' cm — gebraucht werden ' + k(zuBreit.w) + ' cm.<br>' +
        (kleiner ? 'Größe auf ' + k(kleiner) + ' cm reduzieren' : 'Größe reduzieren') +
        ' oder auf ' + passt + ' Zeichen kürzen.';
      box.appendChild(w2);
      s._zuBreit = true;
    } else {
      s._zuBreit = false;
      if (genutzt.length && font) {
        var laengste = genutzt.reduce(function (m, t) {
          return Math.max(m, seitenBreiteCm(t, font, s.groesse));
        }, 0);
        var o = document.createElement('div');
        o.className = 'wl__block-ok';
        o.textContent = 'Passt — ' + k(laengste) + ' × ' + k(seitenHoeheCm(genutzt.length, s.groesse)) +
          ' cm von ' + a.w + ' × ' + k(a.h) + ' cm belegt' + (font.css ? '.' : ' (geschätzt).');
        box.appendChild(o);
      }
    }
    return box;
  }

  /* Ziehgriff an der Seiten-Text-Vorschau (Hinten/Links/Rechts) -
     baugleich mit stickerei-karte.js aktiviereTextGriff(). Waehrend des
     Ziehens wird NICHT aktualisiereSeiten()/zeichneSeitenBloecke()
     aufgerufen (das wuerde den Block inkl. Griff neu aufbauen und die
     laufende Drag-Geste kappen) - nur Schriftgroesse-Style und die line
     item properties werden live aktualisiert. Deckel/Warnung etc.
     werden erst beim Loslassen final nachgezogen. */
  function aktiviereTextGriff(textEl, feldEl, a, s, nZeilen, deckel, sl, slval) {
    var griff = document.createElement('button');
    griff.type = 'button';
    griff.className = 'wl__resize-handle';
    griff.setAttribute('aria-label', 'Schriftgröße durch Ziehen ändern');
    griff.title = 'Ziehen, um die Schriftgröße zu ändern';
    griff.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 20L20 4M20 4h-6M20 4v6M4 20h6M4 20v-6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    textEl.appendChild(griff);

    griff.addEventListener('pointerdown', function (start) {
      start.preventDefault();
      start.stopPropagation();
      var prev = textEl.closest('.wl__blockprev');
      var ppc = prev.clientWidth / parseFloat(prev.dataset.areaw);
      if (!ppc) return;
      var unten = feldEl.getBoundingClientRect().bottom;
      var k2 = (nZeilen - 1) * LINE_PITCH + 1 + DESCENDER;
      try { griff.setPointerCapture(start.pointerId); } catch (err) {}
      prev.classList.add('wl__blockprev--resizing');

      function bewegen(e) {
        var hoeheCmZiel = (unten - e.clientY) / ppc;
        var neu = hoeheCmZiel / k2;
        neu = Math.min(deckel, Math.max(a.min, Math.round(neu * 10) / 10));
        if (neu === s.groesse) return;
        s.groesse = neu;
        textEl.dataset.size = neu;
        textEl.style.fontSize = (neu / CAP_RATIO * ppc) + 'px';
        if (sl) sl.value = neu;
        if (slval) slval.innerHTML = k(neu) + ' cm <em>· ' + seitenGroessenwort(neu) + '</em>';
        schreibeProperties();
        pruefe();
      }

      function ende() {
        prev.classList.remove('wl__blockprev--resizing');
        griff.removeEventListener('pointermove', bewegen);
        griff.removeEventListener('pointerup', ende);
        griff.removeEventListener('pointercancel', ende);
        aktualisiereSeiten();
      }

      griff.addEventListener('pointermove', bewegen);
      griff.addEventListener('pointerup', ende);
      griff.addEventListener('pointercancel', ende);
    });
  }

  function skaliereSeiten() {
    root.querySelectorAll('.wl__blockprev').forEach(function (prev) {
      var ppc = prev.clientWidth / parseFloat(prev.dataset.areaw);
      var t = prev.querySelector('.wl__bp-txt');
      if (t) t.style.fontSize = (parseFloat(t.dataset.size) / CAP_RATIO * ppc) + 'px';
    });
  }

  function aktualisiereSeiten(fokus, pos) {
    zeichneSeitenBloecke();
    schreibeProperties();
    pruefe();
    if (fokus) {
      var elFokus = root.querySelector('[data-key="' + fokus + '"]');
      if (elFokus) {
        var p = pos === undefined ? elFokus.value.length : pos;
        elFokus.focus();
        elFokus.setSelectionRange(p, p);
      }
    }
  }

  /* ---------- Kacheln ---------- */
  function zeichnePositionen() {
    el.positionen.innerHTML = '';
    el.positionen.style.gridTemplateColumns = 'repeat(' + Math.min(AKTIV.length, 4) + ',1fr)';

    var jetzt = preisFuer(anzahl());
    var mehr = preisFuer(anzahl() + 1);
    var aufschlag = (jetzt !== null && mehr !== null) ? mehr - jetzt : null;

    AKTIV.forEach(function (p) {
      var a = CFG.flaechen[p];
      var an = stand.gewaehlt[p];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl__kachel';
      b.setAttribute('aria-pressed', an);

      /* Nicht gewaehlte Kacheln zeigen, was das Hinzufuegen kostet.
         Bei gewaehlten waere dieselbe Zahl irrefuehrend - sie ist ja
         bereits im Preis enthalten. */
      var zusatz = '';
      if (!an && aufschlag !== null && aufschlag > 0) {
        zusatz = '<span class="wl__kachel-plus">+ ' + preisText(aufschlag) + '</span>';
      }

      b.innerHTML = positionsSkizze(p) +
        '<span class="wl__kachel-name">' + a.kurz + '</span>' +
        '<span class="wl__kachel-mass">' + a.w + '×' + k(a.h) + ' cm</span>' +
        zusatz;

      b.addEventListener('click', function () {
        if (stand.gewaehlt[p] && anzahl() === 1) return;
        stand.gewaehlt[p] = !stand.gewaehlt[p];
        zeichnePositionen();
        zeichneSichtbarkeiten();
        zeichneSeitenBloecke();
        varianteSetzen();
        alles();
      });
      el.positionen.appendChild(b);
    });

    var n = anzahl();
    var text = n === 1 ? '1 Position' : n + ' Positionen';
    el.preiszeile.innerHTML = jetzt !== null
      ? '<strong>' + text + '</strong> · <span class="wl__preis">' + preisText(jetzt) + '</span>'
      : 'Der Preis richtet sich nach der Anzahl der Positionen.';
  }

  function zeichneArten() {
    el.arten.innerHTML = '';
    Object.keys(ARTEN).forEach(function (s) {
      var a = ARTEN[s];
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl__kachel';
      b.setAttribute('aria-pressed', stand.art === s);
      b.innerHTML = '<span class="wl__kachel-icon" aria-hidden="true">' + a.icon + '</span>' +
        '<span class="wl__kachel-name">' + a.name + '</span>' +
        '<span class="wl__kachel-mass">' + a.note + '</span>';
      b.addEventListener('click', function () {
        stand.art = s;
        zeichneArten();
        zeichneZuordnung();
        alles();
      });
      el.arten.appendChild(b);
    });
  }

  /* ---------- Variante ---------- */
  function feuere(e) {
    e.dispatchEvent(new Event('change', { bubbles: true }));
    e.dispatchEvent(new Event('input', { bubbles: true }));
  }

  /* Welcher Optionswert steht fuer diese Anzahl Positionen?
     Erst der erwartete Name, sonst der Wert an der passenden Stelle
     der Liste. Letzteres rettet uns, wenn die Stufen im Admin anders
     benannt sind - solange sie nach Anzahl sortiert sind. */
  function stufenWert(n) {
    if (n === undefined) n = anzahl();
    var erwartet = n === 1 ? '1 Position' : n + ' Positionen';
    var stufen = CFG.stufen || [];
    if (stufen.indexOf(erwartet) !== -1) return erwartet;
    if (stufen.length >= n) return stufen[n - 1];
    return erwartet;
  }

  /* ---------- Preise ----------
     Gerechnet wird aus der Variantenkarte, nicht aus dem Preis oben
     auf der Seite. Dadurch steht die Zahl schon da, bevor Shopify die
     Variante nachgeladen hat - der Kunde sieht sofort, was ein
     weiterer Stickplatz kostet. */
  var geld = null;
  try {
    geld = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: CFG.waehrung || 'EUR'
    });
  } catch (e) { geld = null; }

  function preisText(cent) {
    if (cent === null || cent === undefined) return '';
    var betrag = cent / 100;
    return geld ? geld.format(betrag) : betrag.toFixed(2).replace('.', ',') + ' €';
  }

  function preisFuer(n) {
    var v = CFG.varianten[CFG.farbeAktuell + '|' + stufenWert(n)];
    return v ? v.preis : null;
  }

  function varianteSetzen() {
    var wert = stufenWert();
    var treffer = false;

    document.querySelectorAll(
      'variant-selects input[type=radio], variant-radios input[type=radio], .product-form__input input[type=radio]'
    ).forEach(function (i) {
      if (i.value === wert) { treffer = true; if (!i.checked) { i.checked = true; feuere(i); } }
    });

    if (!treffer) {
      document.querySelectorAll('variant-selects select, .product-form__input select').forEach(function (s) {
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value === wert) {
            treffer = true;
            if (s.value !== wert) { s.value = wert; feuere(s); }
          }
        }
      });
    }

    if (!treffer) {
      var v = CFG.varianten[CFG.farbeAktuell + '|' + wert];
      if (!v) return;
      var id = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (id) { id.value = v.id; feuere(id); }
    }
  }

  /* ---------- Datei ---------- */
  function marke(text, art) {
    return '<span class="wl__marke wl__marke--' + art + '">' + text + '</span>';
  }

  function zeigeMarken(liste) {
    el.marken.hidden = liste.length === 0;
    el.marken.innerHTML = liste.join('');
  }

  /* ---------- Farberkennung ----------
     Drei Schritte, damit auch kleine Flaechen wie ein Auge auftauchen:

     1. Feiner rechnen. 220 statt 120 Punkte Kantenlaenge und 16 statt
        8 Stufen je Kanal - ein Pupillenpunkt verschwindet sonst im
        Raster.
     2. Aehnliche Toene zusammenfassen. Weiche Kanten erzeugen Dutzende
        Zwischentoene; liegen zwei Toene nah beieinander, gelten sie
        als eine Farbe.
     3. Sehr feine Schwelle, aber Mindestzahl an Punkten. So ueberlebt
        das Auge, waehrend einzelne Kantenpixel draussen bleiben.

     Zusaetzlich wird ein flaechiger Hintergrund erkannt: Sind die vier
     Ecken deckend und gleich, ist das kein Logoton, sondern ein nicht
     freigestelltes Bild. Er wird nicht als Garnfarbe angeboten.

     Perfekt wird das nie - deshalb kann der Kunde Zeilen ergaenzen
     und entfernen. */
  function abstand(a, b) {
    var dr = a[0] - b[0], dg = a[1] - b[1], db = a[2] - b[2];
    return Math.sqrt(dr * dr + dg * dg + db * db);
  }

  function hex(rgb) {
    return '#' + rgb.map(function (v) {
      return ('0' + Math.round(v).toString(16)).slice(-2);
    }).join('');
  }

  function zaehleFarben(quelle) {
    var raster = 220;
    var c = document.createElement('canvas');
    c.width = raster;
    c.height = raster;
    var x = c.getContext('2d', { willReadFrequently: true });
    var d;
    try {
      x.drawImage(quelle, 0, 0, raster, raster);
      d = x.getImageData(0, 0, raster, raster).data;
    } catch (e) {
      return null;
    }

    function punkt(px, py) {
      var i = (py * raster + px) * 4;
      return { a: d[i + 3], rgb: [d[i], d[i + 1], d[i + 2]] };
    }

    var ecken = [punkt(2, 2), punkt(raster - 3, 2), punkt(2, raster - 3), punkt(raster - 3, raster - 3)];
    var hintergrund = null;
    if (ecken.every(function (e) { return e.a > 200; })) {
      var gleich = ecken.every(function (e) { return abstand(e.rgb, ecken[0].rgb) < 26; });
      if (gleich) hintergrund = ecken[0].rgb;
    }

    var eimer = {};
    var sichtbar = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 40) continue;
      var rgb = [d[i], d[i + 1], d[i + 2]];
      if (hintergrund && abstand(rgb, hintergrund) < 26) continue;
      var key = (d[i] >> 4) + '-' + (d[i + 1] >> 4) + '-' + (d[i + 2] >> 4);
      if (!eimer[key]) eimer[key] = { n: 0, r: 0, g: 0, b: 0 };
      eimer[key].n++;
      eimer[key].r += d[i];
      eimer[key].g += d[i + 1];
      eimer[key].b += d[i + 2];
      sichtbar++;
    }
    if (!sichtbar) return null;

    var roh = [];
    for (var kk in eimer) {
      var e = eimer[kk];
      roh.push({ n: e.n, rgb: [e.r / e.n, e.g / e.n, e.b / e.n] });
    }
    roh.sort(function (a, b) { return b.n - a.n; });

    /* Zusammenfassen. Der Wert entscheidet, wie streng getrennt wird:
       kleiner = mehr Einzelfarben, groesser = nur noch Hauptfarben.
       72 fasst Schattierungen und weiche Kanten mit ihrem Grundton
       zusammen und laesst deutlich verschiedene Toene stehen. */
    var behalten = [];
    roh.forEach(function (t) {
      for (var j = 0; j < behalten.length; j++) {
        if (abstand(t.rgb, behalten[j].rgb) < 72) {
          var ges = behalten[j].n + t.n;
          for (var kanal = 0; kanal < 3; kanal++) {
            behalten[j].rgb[kanal] =
              (behalten[j].rgb[kanal] * behalten[j].n + t.rgb[kanal] * t.n) / ges;
          }
          behalten[j].n = ges;
          return;
        }
      }
      behalten.push({ n: t.n, rgb: t.rgb.slice() });
    });

    /* Mindestflaeche. 1,5 Prozent trifft die Hauptfarben und laesst
       Schatten, Kanten und winzige Details draussen. Sehr kleine, aber
       gewollte Flaechen - ein Auge etwa - ergaenzt der Kunde ueber
       "Farbe ergaenzen". Das ist ehrlicher, als die Automatik so
       empfindlich zu stellen, dass sie bei jedem Logo Unsinn findet. */
    var mindest = Math.max(60, sichtbar * 0.015);
    var echte = behalten
      .filter(function (t) { return t.n >= mindest; })
      .sort(function (a, b) { return b.n - a.n; })
      .slice(0, 6)
      .map(function (t) { return { anteil: t.n / sichtbar, hex: hex(t.rgb) }; });

    return {
      anzahl: echte.length,
      farben: echte,
      hintergrund: hintergrund ? hex(hintergrund) : null
    };
  }

  /* Beschneidet ein hochgeladenes Logo auf die enge Bounding-Box der
     sichtbaren Pixel (nicht Hintergrund, nicht transparent) und
     liefert dabei gleich das echte Seitenverhaeltnis mit.

     WICHTIG, warum das ein eigener Schritt ist und nicht einfach in
     zaehleFarben() mitlaeuft: Die zeichnet absichtlich in ein
     QUADRATISCHES Raster (220x220), weil das fuer die Farbzaehlung
     egal ist. Fuer eine Breiten/Hoehen-Messung ist das aber toedlich -
     ein breites Logo wie ein Schriftzug wuerde beim Quetschen ins
     Quadrat Richtung 1:1 verzerrt gemessen. Deshalb hier im EIGENEN
     Seitenverhaeltnis der Datei zeichnen, dann messen. */
  function beschneideLogo(quelle) {
    var w = quelle.naturalWidth || quelle.width || 0;
    var h = quelle.naturalHeight || quelle.height || 0;
    if (!w || !h) return null;

    var kante = 1000;
    var skala = Math.min(kante / w, kante / h, 1) || 1;
    var cw = Math.max(1, Math.round(w * skala));
    var ch = Math.max(1, Math.round(h * skala));

    var c = document.createElement('canvas');
    c.width = cw;
    c.height = ch;
    var x = c.getContext('2d', { willReadFrequently: true });
    var d;
    try {
      x.drawImage(quelle, 0, 0, cw, ch);
      d = x.getImageData(0, 0, cw, ch).data;
    } catch (e) {
      return null;
    }

    function punkt(px, py) {
      var i = (py * cw + px) * 4;
      return { a: d[i + 3], rgb: [d[i], d[i + 1], d[i + 2]] };
    }
    var ecken = [punkt(1, 1), punkt(cw - 2, 1), punkt(1, ch - 2), punkt(cw - 2, ch - 2)];
    var hintergrund = null;
    if (ecken.every(function (e) { return e.a > 200; })) {
      var gleich = ecken.every(function (e) { return abstand(e.rgb, ecken[0].rgb) < 26; });
      if (gleich) hintergrund = ecken[0].rgb;
    }

    var minX = cw, minY = ch, maxX = -1, maxY = -1;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 20) continue;
      if (hintergrund && abstand([d[i], d[i + 1], d[i + 2]], hintergrund) < 26) continue;
      var idx = i / 4;
      var px = idx % cw, py = Math.floor(idx / cw);
      if (px < minX) minX = px;
      if (px > maxX) maxX = px;
      if (py < minY) minY = py;
      if (py > maxY) maxY = py;
    }
    if (maxX < 0) return null;

    var bw = maxX - minX + 1, bh = maxY - minY + 1;
    var aus = document.createElement('canvas');
    aus.width = bw;
    aus.height = bh;
    aus.getContext('2d').drawImage(c, minX, minY, bw, bh, 0, 0, bw, bh);

    return { verhaeltnis: bw / bh, datenUrl: aus.toDataURL('image/png') };
  }

  function ladePdfJs() {
    return new Promise(function (loesen, ablehnen) {
      if (window.pdfjsLib) return loesen(window.pdfjsLib);
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';
      s.onload = function () {
        try {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc =
            'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
        } catch (e) {}
        loesen(window.pdfjsLib);
      };
      s.onerror = ablehnen;
      document.head.appendChild(s);
    });
  }

  function verarbeitePdf(datei) {
    zeigeMarken([marke('Vektordatei', 'gut'), marke('Vorschau wird erstellt', 'warn')]);

    ladePdfJs().then(function (lib) {
      return datei.arrayBuffer().then(function (puffer) {
        return lib.getDocument({ data: puffer }).promise;
      });
    }).then(function (pdf) {
      return pdf.getPage(1);
    }).then(function (seite) {
      var breit = 700;
      var basis = seite.getViewport({ scale: 1 });
      var sicht = seite.getViewport({ scale: breit / basis.width });
      var c = document.createElement('canvas');
      c.width = sicht.width;
      c.height = sicht.height;
      return seite.render({ canvasContext: c.getContext('2d'), viewport: sicht }).promise
        .then(function () { return c; });
    }).then(function (c) {
      var farbInfo = zaehleFarben(c);
      var zuschnitt = beschneideLogo(c);
      stand.seiten = (zuschnitt && zuschnitt.verhaeltnis) || (c.width / c.height) || 1;
      el.logo.src = (zuschnitt && zuschnitt.datenUrl) || c.toDataURL('image/png');
      el.logoBox.hidden = false;
      el.leer.hidden = true;

      var liste = [marke('Vektordatei', 'gut')];
      uebernehmeFarben(farbInfo, liste);
      zeigeMarken(liste);
      alles();
    }).catch(function () {
      /* Faellt die Bibliothek aus, bleibt die Bestellung moeglich -
         der Kunde gibt die Art des Logos dann selbst an. */
      stand.farbAnzahl = null;
      el.logoBox.hidden = true;
      el.leer.hidden = false;
      el.leer.textContent = 'PDF hochgeladen — keine Vorschau möglich';
      zeigeMarken([marke('Vektordatei', 'gut'), marke('Keine Vorschau', 'warn')]);
      alles();
    });
  }

  function verarbeiteBild(datei, istSvg) {
    var leser = new FileReader();
    leser.onload = function (ev) {
      /* In ein TEMPORAeRES Image laden, nicht direkt in el.logo - sonst
         wuerde das gleich unten folgende Ersetzen von el.logo.src durch
         die zugeschnittene Version ein neues onload auf el.logo ausloesen
         und die ganze Verarbeitung erneut anstossen. */
      var lade = new Image();
      lade.onload = function () {
        var farbInfo = zaehleFarben(lade);
        var zuschnitt = beschneideLogo(lade);
        stand.seiten = (zuschnitt && zuschnitt.verhaeltnis) ||
          (lade.naturalWidth / lade.naturalHeight) || 1;

        el.logo.src = (zuschnitt && zuschnitt.datenUrl) || ev.target.result;
        el.logoBox.hidden = false;
        el.leer.hidden = true;

        var liste = [];
        if (istSvg) {
          liste.push(marke('Vektordatei', 'gut'));
        } else {
          el.info.textContent = lade.naturalWidth + ' × ' + lade.naturalHeight + ' px';
          liste.push(lade.naturalWidth < 1000
            ? marke('Auflösung knapp', 'warn')
            : marke('Auflösung gut', 'gut'));
        }

        uebernehmeFarben(farbInfo, liste);

        zeigeMarken(liste);
        alles();
      };
      lade.src = ev.target.result;
    };
    leser.readAsDataURL(datei);
  }

  /* ---------- Farbzuordnung ----------
     Eine Zeile je erkannter Logofarbe: Punkt in der erkannten Farbe,
     Feld fuer den Bereich, Auswahl der Garnfarbe. Die Auswahlfelder
     uebernehmen ihre Eintraege aus dem Garnfarben-Raster darueber,
     damit die 84 Farben nur einmal im Theme stehen. */
  function garnQuelle() {
    return root.querySelector('#wl-yarn-einzel [data-garn-select]');
  }

  function garnTonKarte() {
    var karte = {};
    root.querySelectorAll('[data-garn-value][data-garn-hex]').forEach(function (b) {
      karte[b.dataset.garnValue] = b.dataset.garnHex;
    });
    return karte;
  }

  function uebernehmeFarben(ergebnis, liste) {
    if (!ergebnis) {
      stand.farbAnzahl = null;
      stand.farbListe = [];
      return;
    }
    stand.farbAnzahl = ergebnis.anzahl;
    stand.farbListe = ergebnis.farben.slice();
    if (liste) {
      liste.push(marke(ergebnis.anzahl + (ergebnis.anzahl === 1 ? ' Farbe erkannt' : ' Farben erkannt'),
        ergebnis.anzahl > 4 ? 'warn' : 'gut'));
      if (ergebnis.hintergrund) {
        liste.push(marke('Hintergrund nicht transparent', 'warn'));
      }
    }
    stand.art = ergebnis.anzahl > 4 ? 'komplex' : (ergebnis.anzahl === 1 ? 'schrift' : 'symbol');
    zeichneArten();
    zeichneZuordnung();
  }

  function zeichneZuordnung() {
    var mehrfarbig = stand.farbAnzahl !== null && stand.farbAnzahl > 1 && stand.art !== 'komplex';

    el.zuordnung.hidden = !mehrfarbig;
    el.yarnEinzel.hidden = mehrfarbig;

    var einzel = garnQuelle();
    if (einzel) einzel.disabled = mehrfarbig;

    if (!mehrfarbig) { el.zeilen.innerHTML = ''; return; }

    var toene = garnTonKarte();
    var vorlage = garnQuelle();
    var alt = stand.zuordnung.slice();
    stand.zuordnung = [];
    el.zeilen.innerHTML = '';

    stand.farbListe.forEach(function (f, i) {
      var eintrag = alt[i] || { bereich: '', garn: '' };
      stand.zuordnung.push(eintrag);

      var zeile = document.createElement('div');
      zeile.className = 'wl__zeile';

      var punkt = document.createElement('span');
      punkt.className = 'wl__punkt';
      punkt.style.background = f.hex;
      punkt.title = f.eigen ? 'Selbst ergänzt' : 'Erkannte Farbe ' + (i + 1);
      zeile.appendChild(punkt);

      var bereich = document.createElement('input');
      bereich.type = 'text';
      bereich.className = 'wl__bereich';
      bereich.maxLength = 30;
      bereich.placeholder = i === 0 ? 'z. B. Nase' : 'Bereich';
      bereich.value = eintrag.bereich;
      bereich.addEventListener('input', function () {
        eintrag.bereich = bereich.value;
        schreibeProperties();
      });
      zeile.appendChild(bereich);

      var wahl = document.createElement('select');
      wahl.className = 'wl__garn';
      wahl.innerHTML = vorlage ? vorlage.innerHTML : '<option value="">Bitte wählen</option>';
      wahl.value = eintrag.garn;
      wahl.addEventListener('change', function () {
        eintrag.garn = wahl.value;
        punktGarn.style.background = toene[wahl.value] || 'transparent';
        punktGarn.style.borderStyle = toene[wahl.value] ? 'solid' : 'dashed';
        schreibeProperties();
        pruefe();
      });
      zeile.appendChild(wahl);

      var punktGarn = document.createElement('span');
      punktGarn.className = 'wl__punkt wl__punkt--garn';
      punktGarn.style.background = toene[eintrag.garn] || 'transparent';
      punktGarn.style.borderStyle = toene[eintrag.garn] ? 'solid' : 'dashed';
      zeile.appendChild(punktGarn);

      if (stand.farbListe.length > 1) {
        var weg = document.createElement('button');
        weg.type = 'button';
        weg.className = 'wl__weg';
        weg.setAttribute('aria-label', 'Farbe entfernen');
        weg.textContent = '×';
        weg.addEventListener('click', function () {
          stand.farbListe.splice(i, 1);
          stand.zuordnung.splice(i, 1);
          stand.farbAnzahl = stand.farbListe.length;
          zeichneZuordnung();
          alles();
        });
        zeile.appendChild(weg);
      }

      el.zeilen.appendChild(zeile);
    });

    var mehr = document.createElement('button');
    mehr.type = 'button';
    mehr.className = 'wl__mehr';
    mehr.textContent = '+ Farbe ergänzen';
    mehr.addEventListener('click', function () {
      stand.farbListe.push({ anteil: 0, hex: '#cfccc5', eigen: true });
      stand.farbAnzahl = stand.farbListe.length;
      zeichneZuordnung();
      alles();
    });
    el.zeilen.appendChild(mehr);
  }

  function zuordnungText() {
    return stand.zuordnung.map(function (z, i) {
      var wo = z.bereich ? z.bereich : 'Farbe ' + (i + 1);
      return wo + ': ' + (z.garn || '—');
    }).join(' | ');
  }

  function zuordnungVollstaendig() {
    return stand.zuordnung.every(function (z) { return !!z.garn; });
  }

  el.zone.addEventListener('click', function () { el.datei.click(); });
  el.datei.addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    if (!f) return;

    stand.hatDatei = true;
    stand.dateiName = f.name;
    stand.istPdf = /\.pdf$/i.test(f.name) || f.type === 'application/pdf';
    var istSvg = /\.svg$/i.test(f.name) || /svg/i.test(f.type);

    el.zone.classList.add('ist-bereit');
    el.name.textContent = f.name;
    el.knopf.textContent = 'Ändern';
    el.info.textContent = stand.istPdf || istSvg ? 'Vektordatei, beste Stickqualität' : 'Wird geprüft …';

    if (stand.istPdf) { verarbeitePdf(f); } else { verarbeiteBild(f, istSvg); }
  });

  /* ---------- Groesse, Vorschau, Pruefung ---------- */
  function masseAngleichen(quelle) {
    var a = CFG.flaechen.vorne;
    var mh = maxHoehe();
    var b = parseFloat(el.breite.value) || 1;
    var h = parseFloat(el.hoehe.value) || 1;

    if (quelle === 'breite') { h = b / stand.seiten; } else { b = h * stand.seiten; }
    if (h > mh) { h = mh; b = h * stand.seiten; }
    if (b > a.w) { b = a.w; h = b / stand.seiten; }

    stand.breite = b;
    stand.hoehe = h;
    el.breite.value = b.toFixed(1);
    el.hoehe.value = h.toFixed(1);
    el.breite.max = a.w;
    el.hoehe.max = mh;
  }

  function zeichneVorschau() {
    var p = 'vorne';
    var a = CFG.flaechen[p];
    var foto = CFG.fotos[p];
    if (!foto) return;

    var quelle = fotoQuelle(foto, 'vorne');

    el.vorschau.style.aspectRatio = foto.ratio;
    el.vorschau.style.backgroundImage = 'url("' + quelle + '")';
    el.vorschau.classList.toggle('ist-gespiegelt', !!foto.spiegeln);

    var breitePx = el.vorschau.clientWidth;
    if (!breitePx) return;
    var ppc = breitePx / foto.cmWide;
    var hochCm = foto.cmWide / foto.ratio;
    var hub = (foto.liftCm || 0) / hochCm;

    el.flaeche.style.width = (a.w * ppc) + 'px';
    el.flaeche.style.height = (a.h * ppc) + 'px';
    el.flaeche.style.left = (foto.cx * 100) + '%';
    el.flaeche.style.top = ((foto.cy - hub) * 100) + '%';

    if (stand.hatDatei && !el.logoBox.hidden) {
      el.logoBox.style.width = (stand.breite * ppc) + 'px';
      el.logoBox.style.height = (stand.hoehe * ppc) + 'px';
    }
  }

  function schreibeProperties() {
    el.props.innerHTML = '';
    var gewaehlte = AKTIV.filter(function (p) { return stand.gewaehlt[p]; });

    function feld(name, wert) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = 'properties[' + name + ']';
      i.value = wert;
      el.props.appendChild(i);
    }

    feld('Positionen', gewaehlte.map(function (p) { return CFG.flaechen[p].kurz; }).join(' + '));

    if (stand.gewaehlt.vorne) {
      feld('Logogröße', k(stand.breite) + ' × ' + k(stand.hoehe) + ' cm');
      feld('Logo-Art', ARTEN[stand.art].name);
      if (stand.farbAnzahl !== null) { feld('Erkannte Farben', String(stand.farbAnzahl)); }
      if (!el.zuordnung.hidden && stand.zuordnung.length) {
        feld('Garnfarben', zuordnungText());
      }
    }

    gewaehlte.filter(function (p) { return p !== 'vorne'; }).forEach(function (p) {
      var a = CFG.flaechen[p], s = stand.daten[p];
      var f = CFG.schriften.filter(function (x) { return x.id === s.schrift; })[0];
      var txt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim(); }).join(' | ');
      feld(a.label + ' — Text', txt);
      feld(a.label + ' — Schriftart', f ? f.name : '');
      feld(a.label + ' — Größe', k(s.groesse) + ' cm');
    });
  }

  function braucchtAnfrage() {
    return stand.art === 'komplex' || (stand.farbAnzahl !== null && stand.farbAnzahl > 4);
  }

  function pruefe() {
    var probleme = [];

    if (stand.gewaehlt.vorne && !stand.hatDatei) probleme.push('Logo fehlt');

    AKTIV.filter(function (p) { return p !== 'vorne' && stand.gewaehlt[p]; }).forEach(function (p) {
      var a = CFG.flaechen[p], s = stand.daten[p];
      var hatText = s.zeilen.slice(0, a.zeilen).some(function (t) { return t.trim(); });
      if (!hatText) probleme.push(a.label + ': Text fehlt');
      else if (!s.schrift) probleme.push(a.label + ': Schriftart fehlt');
      else if (s._zuBreit) probleme.push(a.label + ': Text passt nicht in die Fläche');
    });

    var seiteAktiv = seitePosAktiv();

    if (!el.zuordnung.hidden) {
      if (!zuordnungVollstaendig()) probleme.push('Garnfarbe je Logofarbe wählen');
    } else {
      var brauchtGarn = stand.gewaehlt.vorne && stand.art !== 'komplex';
      var garn = root.querySelector('[name="properties[Garnfarbe]"]');
      if (brauchtGarn && (!garn || !garn.value)) probleme.push('Garnfarbe für Logo fehlt');
    }

    if (seiteAktiv) {
      var garnText = root.querySelector('[name="properties[Garnfarbe Text]"]');
      if (!garnText || !garnText.value) probleme.push('Garnfarbe für Text fehlt');
    }

    var anfrage = stand.gewaehlt.vorne && braucchtAnfrage();
    el.anfrage.hidden = !anfrage;
    if (anfrage) {
      el.anfrage.innerHTML =
        'Mehrfarbige oder komplexe Logos stimmen wir kurz mit dir ab, damit die Stickerei sauber wird. ' +
        'Schick uns dein Logo — du bekommst schnell ein Angebot.' +
        '<a href="' + (CFG.anfrageLink || '/pages/kontakt') + '">Angebot anfragen</a>';
    }

    el.blocker.innerHTML = probleme.map(function (t) { return '<li>' + t + '</li>'; }).join('');

    var sperren = probleme.length > 0 || anfrage;

    /* Steckt diese Karte in einem gerade ausgeblendeten
       Veredelungs-Umschalter-Panel (veredelung-auswahl.liquid, Fall
       "Stickerei + DTF"), zaehlt ihre Pruefung nicht - sonst blockiert
       die unsichtbare Karte den Kauf ueber die andere Veredelungsart. */
    var eigenesPanel = root.closest('.va-panel');
    if (!(eigenesPanel && eigenesPanel.hidden)) {
      document.querySelectorAll(
        'form[action*="/cart/add"] [type=submit], form[action*="/cart/add"] .product-form__submit'
      ).forEach(function (b) { b.disabled = sperren; });
    }

    return !sperren;
  }

  var form = document.querySelector('form[action*="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function (e) {
      if (!pruefe()) {
        e.preventDefault();
        e.stopPropagation();
        el.blocker.scrollIntoView({ block: 'center' });
      }
    }, true);
  }

  function alles(quelle) {
    if (stand.gewaehlt.vorne) {
      masseAngleichen(quelle);

      var a = CFG.flaechen.vorne;
      el.grenze.textContent = 'Fläche ' + a.w + ' × ' + k(a.h) + ' cm. Höhe bei Logos höchstens ' +
        k(maxHoehe()) + ' cm.';

      var eng = stand.breite >= a.w - 0.05 || stand.hoehe >= maxHoehe() - 0.05;
      el.warnung.hidden = !eng;
      if (eng) el.warnung.textContent = 'Grenze erreicht — größer geht auf dieser Position nicht.';
      el.vorschau.classList.toggle('ist-eng', eng);

      zeichneVorschau();

      document.getElementById('wl-belegt').textContent = stand.hatDatei
        ? 'Belegt ' + k(stand.breite) + ' × ' + k(stand.hoehe) + ' cm von ' + a.w + ' × ' + k(a.h) + ' cm.'
        : '';
    }

    schreibeProperties();
    pruefe();

    /* Eigenes Ereignis statt uns auf ein natives input/change/click zu
       verlassen: Datei-Uploads werden ASYNCHRON verarbeitet (FileReader
       + Image.onload in verarbeiteBild/verarbeitePdf) - das native
       'change'-Ereignis des <input type=file> feuert und laesst
       wl-galerie-vorschau.js (eigene Datei/Closure ohne Zugriff hierauf)
       schon VOR Ende der Bildverarbeitung einmal pruefen, findet dann
       hatDatei/ist-bereit noch nicht gesetzt und bleibt leer - danach
       feuert kein weiteres Ereignis mehr, das nachtraeglich korrigieren
       wuerde. Bug, live gefunden (27.09.2026): Logo-Upload aktualisierte
       die kleine Karte korrekt, die grosse Live-Vorschau im Produktbild
       blieb aber dauerhaft unsichtbar. alles() laeuft dagegen IMMER erst
       NACH Abschluss der Verarbeitung (wird aus dem Image.onload-Callback
       aufgerufen) - ein eigenes Ereignis genau an dieser Stelle schliesst
       die Luecke zuverlaessig, ohne jede einzelne Aufrufstelle anfassen
       zu muessen. */
    root.dispatchEvent(new CustomEvent('lc-alles', { bubbles: true }));
  }

  el.breite.addEventListener('input', function () { alles('breite'); });
  el.hoehe.addEventListener('input', function () { alles('hoehe'); });

  /* Ziehgriff an der Logo-Vorschau, analog zum Motiv-Griff bei DTF
     (dtf-optionen.js). zeichneVorschau()/alles() bauen hier KEIN DOM
     neu auf (anders als bei der Stickerei-Karte) - deshalb kann waehrend
     des Ziehens direkt und live alles('breite') aufgerufen werden, ganz
     so, als haette der Kunde die Breite eingetippt.

     Generisch gehalten (griffEl/flaecheEl/boxEl statt fest el.griff/
     el.flaeche/el.logoBox als Parameter): dieselbe Funktion bedient
     sowohl den echten Griff in der kleinen Karte als auch den frisch
     verdrahteten Griff auf der GEKLONTEN Vorschau im Produktbild
     (siehe root.lcLogoGriffFuerKlon unten / wl-galerie-vorschau.js).
     Geschrieben wird in JEDEM Fall auf das echte el.breite/el.hoehe und
     ueber alles('breite') - der Klon hat kein eigenes Modell, er ist
     nur eine andere Ansicht auf denselben stand. boxEl wird zusaetzlich
     WAEHREND des Ziehens direkt aktualisiert, damit auch eine geklonte
     Vorschau (die alles() nicht automatisch mit aktualisiert) sofort
     mitwaechst. */
  function verdraheteLogoGriff(griffEl, flaecheEl, boxEl, vorschauWrapEl) {
    griffEl.addEventListener('pointerdown', function (start) {
      if (!stand.hatDatei) return;
      start.preventDefault();
      start.stopPropagation();
      var rect = flaecheEl.getBoundingClientRect();
      var a = CFG.flaechen.vorne;
      if (!rect.width || !a) return;
      var ppc = rect.width / a.w;
      var mitteX = rect.left + rect.width / 2;
      try { griffEl.setPointerCapture(start.pointerId); } catch (err) {}
      if (vorschauWrapEl) vorschauWrapEl.classList.add('ist-resizing');

      function bewegen(e) {
        /* Vorzeichenbehaftet statt Math.abs(): der Griff sitzt an der
           RECHTEN unteren Ecke, der Pfeil zeigt nach rechts-unten =
           groesser. Mit Math.abs() (Betrag des Abstands zur Mitte)
           kehrte sich das jenseits der Mitte um - zog man den Griff
           weit genug ueber die Mitte hinaus nach LINKS, wuchs die
           Distanz zur Mitte wieder und das Logo wurde wieder GROESSER
           statt kleiner. Bug, 27.09.2026 vom Nutzer live gefunden
           ("Pfeil zeigt nach rechts, aendert sich aber beim Ziehen nach
           links"). Jetzt: rechts von der Mitte = groesser, an der
           Mitte oder weiter links = auf das Minimum gekappt, nie wieder
           groesser. */
        var breite = (e.clientX - mitteX) * 2 / ppc;
        var mh = maxHoehe();
        breite = Math.min(a.w, Math.max(0.5, breite));
        var hoehe = breite / stand.seiten;
        if (hoehe > mh) { hoehe = mh; breite = hoehe * stand.seiten; }
        el.breite.value = breite.toFixed(1);
        el.hoehe.value = hoehe.toFixed(1);
        if (boxEl) {
          boxEl.style.width = (breite * ppc) + 'px';
          boxEl.style.height = (hoehe * ppc) + 'px';
        }
        alles('breite');
      }
      function ende() {
        if (vorschauWrapEl) vorschauWrapEl.classList.remove('ist-resizing');
        griffEl.removeEventListener('pointermove', bewegen);
        griffEl.removeEventListener('pointerup', ende);
        griffEl.removeEventListener('pointercancel', ende);
      }
      griffEl.addEventListener('pointermove', bewegen);
      griffEl.addEventListener('pointerup', ende);
      griffEl.addEventListener('pointercancel', ende);
    });
  }
  if (el.griff) verdraheteLogoGriff(el.griff, el.flaeche, el.logoBox, el.vorschau);
  window.addEventListener('resize', function () {
    if (stand.gewaehlt.vorne) zeichneVorschau();
    skaliereSeiten();
  });

  root.addEventListener('change', function (e) {
    if (e.target.closest('.wl__yarn')) { zeichneSeitenBloecke(); pruefe(); }
  });
  root.addEventListener('click', function (e) {
    if (e.target.closest('.wl__yarn')) setTimeout(function () { zeichneSeitenBloecke(); pruefe(); }, 0);
  });

  /* Fehlte bisher komplett (21. September 2026): CFG.farbeAktuell wurde
     nur einmal beim Laden der Seite gesetzt, nie danach - ein
     Farbfoto-Wechsel (CFG.farbFotos) hat den Kunden also nie erreicht,
     wenn er die Variantenfarbe NACH dem Laden umgestellt hat. Die
     Variantenauswahl liegt ausserhalb von #wunschlogo-karte (in
     buy-buttons.liquid), deshalb hier am document lauschen statt am
     eigenen root. */
  document.addEventListener('change', function (e) {
    if (!e.target.closest('variant-selects')) return;
    var neu = aktuelleFarbe();
    if (neu === CFG.farbeAktuell) return;
    CFG.farbeAktuell = neu;
    zeichneSeitenBloecke();
    alles();
  });

  zeichnePositionen();
  zeichneSichtbarkeiten();
  zeichneSeitenBloecke();
  zeichneArten();
  zeichneZuordnung();
  varianteSetzen();
  alles();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { zeichneSeitenBloecke(); });

  /* Fuer die grosse Live-Vorschau im Produktbild (wl-galerie-vorschau.js,
     eigene Datei/Closure ohne Zugriff auf stand/CFG/el hier): baut dort
     auf der GEKLONTEN Vorschau denselben Ziehgriff wie auf der kleinen
     Karte nach - fuers Logo (Vorne) UND fuer Seitentexte. */
  root.lcLogoGriffFuerKlon = function (cloneEl) {
    var griff = cloneEl.querySelector('.wl__resize-handle');
    var flaeche = cloneEl.querySelector('.wl__feldflaeche');
    var box = cloneEl.querySelector('.wl__logo-box');
    if (!griff || !flaeche) return;
    verdraheteLogoGriff(griff, flaeche, box, cloneEl);
  };
  root.lcTextGriffFuerKlon = function (cloneEl, p) {
    var a = CFG.flaechen[p], s = stand.daten[p];
    if (!a || !s) return;
    var genutzt = s.zeilen.slice(0, a.zeilen).filter(function (t) { return t.trim().length; });
    var nZeilen = Math.max(1, genutzt.length);
    var deckel = seitenMaxGroesseFuerZeilen(nZeilen, a);
    var textEl = cloneEl.querySelector('.wl__bp-txt');
    if (!textEl) return;
    var feldEl = cloneEl.querySelector('.wl__bp-field') || cloneEl;
    aktiviereTextGriff(textEl, feldEl, a, s, nZeilen, deckel, null, null);
  };
})();